import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Item, isValidType } from '@platform/template';
import Hyperlink from '../../components/hyperlink';
import {
    getSafeRandom,
    formatNumber,
    formatAcuracyRound,
    toast,
    getSysFieldid,
    getDatetimeFormat as getDateTimeFormat,
    localIsEquelServerZone as localIsEqualServerZone,
    localTimeToServer,
} from '@platform/api';
import classNames from 'classnames';
import {
    timeTypes,
    ROW_STATUS,
    ERROR_SCALE,
    selectTypes,
    dateTypes,
    switchTypes,
    presetColumns,
    pasteDateTypes,
} from '../../utils';
import { getMainId } from '../../../Form/utils';
import { Tooltip, Hexagon } from '@platform/base';
import dayjs from 'dayjs';

const browseEditTypes = new Set(['attachment', 'checkbox_switch', 'switch', 'switch_browse']);

export default class Cell extends Component {
    constructor(props) {
        super(props);
        let { store, rowKey, colKey } = props;
        this.itemID = store.getInstance().itemIDManager.getID({ rowKey, colKey });
        store.getInstance().register(this.itemID, this);

        this.state = { focused: false, showTip: false };
        this.dirty = false; // 值是否修改过
    }

    componentDidMount() {
        window.addEventListener('paste', this.handlePaste);
    }

    render() {
        let { colKey, store, hoverContent } = this.props,
            { itemtype, attrcode, render, visible } = store.getColumnProps(colKey);

        if (isValidType(itemtype)) {
            return this.renderValidCell();
        } else if (
            hoverContent &&
            (attrcode === "opr" || attrcode === 'operate') &&
            itemtype === "customer" &&
            render &&
            visible
        ) {
            return this.renderOperationCell();
        } else {
            return this.renderCustomerCell();
        }
    }

    componentWillUnmount() {
        let { store, rowKey, colKey } = this.props,
            {
                getActiveCell,
                getCellValue,
                getColumnProps,
            } = store,
            { onAfterEvent } = store.getInstance().getComponent('Table')?.current?.props || {},
            isActive = getActiveCell().colKey === colKey && getActiveCell().rowKey === rowKey,
            cellValue = getCellValue(rowKey, colKey),
            { itemtype, languageMeta } = getColumnProps(colKey);

        store.getInstance().unregister(this.itemID, this);
        if (isActive) {
            store.setActiveCell({ colKey: '', rowKey: '' });

            if (this.dirty) {
                if (itemtype === 'residtxt') {
                    cellValue = languageMeta.reduce((value, { index }) => {
                        if (index == 1 || index == '') {
                            value[colKey] = getCellValue(rowKey, colKey);
                        } else {
                            value[colKey + index] = getCellValue(rowKey, colKey + index);
                        }
                        return value;
                    }, {});
                }

                onAfterEvent?.({
                    value: cellValue,
                    oldValue: this.oldValue,
                    componentValue: this.oldComponentValue,
                    event: new Event('FAKE_EVENT'),
                    colKey,
                    rowKey,
                });
            }
        }
        window.removeEventListener('paste', this.handlePaste);
    }

    renderValidCell = () => {
        let { colKey, rowKey, store } = this.props,
            { focused } = this.state,
            {
                getActiveCell,
                getCellProps,
                getColumnProps,
                getStatus,
                setActiveCell,
            } = store,
            columnInfo = getColumnProps(colKey),
            cellProps = getCellProps(rowKey, colKey),
            { alwaysBrowse } = store.getInstance().getComponent('Table').current.props,
            status = getStatus(),
            { itemtype, tabskip, alignment } = columnInfo,
            isEditStatus = status !== 'browse' && itemtype !== 'label' && itemtype !== 'customer',
            isActive = false,
            invalid = false,
            disabled = false;

        // alwaysBrowse给SimpleTable加，switch_browse不显示组件，显示文字
        if (itemtype === 'attachment' || (itemtype === 'switch_browse' && !alwaysBrowse)) {
            isEditStatus = true;
        }

        if (isEditStatus) {
            isActive = getActiveCell().colKey === colKey && getActiveCell().rowKey === rowKey;
            ({ invalid, disabled } = cellProps);
        }

        this.isEditable = isEditStatus && isActive && !disabled;
        let isHasSuffixIcon = status !== 'browse' && !isActive && (selectTypes.has(itemtype) || timeTypes.has(itemtype) || dateTypes.has(itemtype) || itemtype === "refer");

        let cellStyle = {},
            alignClassName = '';

        if (alignment == '1') {
            cellStyle.direction = 'ltr';
            cellStyle.textAlign = 'left';
            alignClassName = 'template-cell-ltr';
        } else if (alignment == '2') {
            cellStyle.textAlign = 'right';
            alignClassName = 'template-cell-rtl';
        } else if (alignment == '3') {
            cellStyle.textAlign = 'center';
            alignClassName = 'template-cell-center';
        }

        return <div
            onFocus={event => {
                if (this.mousedown) { return; }
                event.currentTarget.contains(event.target) && this.setState({ focused: true });

                if (disabled) { return; }

                if (isEditStatus && event.target === event.currentTarget) {
                    setActiveCell({ colKey, rowKey });
                    if (switchTypes.has(itemtype)) {
                        findDOMNode(this)?.querySelector('.template-item-wrapper')?.focus();
                    }
                }
            }}
            onBlur={() => {
                this.setState({ focused: false });
                if (browseEditTypes.has(itemtype)) {
                    setActiveCell({ colKey: '', rowKey: '' });
                }
            }}
            // onClick={this.handleBeforeEvent}
            tabIndex={focused || tabskip ? -1 : 0}
            className={classNames(
                'table-cell',
                `cell-type-${itemtype}`,
                alignClassName,
                {
                    'active-cell': isActive && itemtype !== 'attachment', // YBP-FI-BUG-7438
                    'disabled-cell': disabled,
                    'editable-cell': !disabled,
                    'invalid-cell': invalid,
                    'valid-type': isValidType(itemtype),
                    'focused-cell': focused,
                    'suffixIcon-cell': isHasSuffixIcon,
                },
            )}
            style={cellStyle}
            onMouseDown={() => {
                this.mousedown = true;
                const handleMouseUp = () => {
                    this.mousedown = false;
                    document.removeEventListener('mouseup', handleMouseUp);
                };
                document.addEventListener('mouseup', handleMouseUp);
            }}
            onMouseEnter={() => {
                let { showTip } = this.state;
                let cellDom = findDOMNode(this);
                if (cellDom) {
                    let tipNode = cellDom.querySelector('.table-cell-browse, .cell-hyper'); // 这俩类不会同时存在
                    if (tipNode) {
                        if (tipNode.scrollWidth > tipNode.clientWidth || tipNode.scrollHeight > tipNode.clientHeight) { // 判断高度是为了兼容多行省略的情况
                            !showTip && this.setState({ showTip: true });
                        } else {
                            showTip && this.setState({ showTip: false });
                        }
                    }
                }
            }}
            onClickCapture={() => {
                !disabled && isEditStatus && setActiveCell({ colKey, rowKey });
            }}
        >
            {this.renderPrefixIcon(itemtype, { isEditStatus, isActive }, columnInfo)}
            {this.renderCell({ isEditStatus, isActive })}
            {this.renderSuffixIcon(itemtype, { isEditStatus, isActive, disabled })}
        </div>;
    }

    renderCustomerCell = () => {
        let { rowKey, colKey, store } = this.props,
            {
                getColumnProps,
                getRowData,
                getCellValue,
                getCellProps,
                getStatus,
                setActiveCell,
            } = store,
            columnInfo = getColumnProps(colKey),
            cellProps = getCellProps(rowKey, colKey),
            { disabled } = cellProps,
            { attrcode, render } = columnInfo,
            status = getStatus();
        let row = getRowData(rowKey);

        if (!row) { return null; }

        let { dataIndex } = row;
        row = store.getInstance()._formatOutputRow(row);
        // 兼容旧的render调用方式

        return <div
            className='table-cell'
            tabIndex={presetColumns.has(attrcode) || columnInfo.tabskip ? -1 : 0}
            onFocus={event => {
                if (event.target === event.currentTarget) {
                    let focusableElement = event.currentTarget.querySelector('input');
                    focusableElement?.focus();
                }
            }}
            onMouseDownCapture={() => {
                !disabled && status !== 'browse' && setActiveCell({ colKey, rowKey });
            }
            }
        >
            {render?.(getCellValue(rowKey, attrcode), row, dataIndex)}
        </div>;
    }

    renderOperationCell = () => {
        let { rowKey, colKey, store } = this.props,
            {
                getColumnProps,
                getRowData,
            } = store,
            columnInfo = getColumnProps(colKey),
            { render } = columnInfo;

        let row = getRowData(rowKey);

        if (!row) { return null; }

        let { dataIndex } = row;
        row = store.getInstance()._formatOutputRow(row);

        return <div
            style={{ overflow: 'hidden' }}
            fieldid={getSysFieldid('opr')}
        >
            <div className='operation-wrapper-hover-container'>
                {render?.('', row, dataIndex)}
            </div>
        </div>;
    }

    renderCell = ({ isEditStatus, isActive }) => {
        let { colKey, rowKey, store } = this.props,
            {
                setActiveCell,
                getCellProps,
                getColumnProps,
                getRowData,
                getCellValue,
                getStatus,
                getActiveCell,
                getLocale,
                getConfig,
            } = store,
            { _formatOutputRow } = store.getInstance(),
            {
                onBeforeEvent,
                onAfterEvent,
                defaultRenderStatus,
                renderItems,
                autoRowHeight,
                onValueChange,
                id,
                pageScope,
                currentId,
            } = store.getInstance().getComponent('Table').current.props,
            columnInfo = getColumnProps(colKey),
            locale = getLocale(),
            cellProps = getCellProps(rowKey, colKey),
            {
                itemtype,
                hyperlinkflag: hyperLinkFlag,
                hyperlinktype: hyperLinkType,
                hyperlinkname: hyperLinkName,
                hyperlinkurl: hyperLinkUrl,
                render,
                renderStatus = defaultRenderStatus,
                renderItem,
                datatype,
                hintmessage,
                attachmentParams,
            } = columnInfo,
            cellValue = getCellValue(rowKey, colKey),
            row = getRowData(rowKey),
            rowInfo = { ...row },
            status = getStatus(),
            editType = 'toggle',
            { inputChange, pkname } = getConfig() || {},
            autoFocus = true;

        if (!row || (new Set(['checkbox_switch', 'switch', 'switch_browse']).has(itemtype) && !isEditStatus && (!columnInfo.renderStatus || !render))) { return null; }

        row = _formatOutputRow(row);

        if (Object.prototype.toString.call(cellValue).slice(8, -1) === 'Object') {
            // 有的业务直接修改row的引用设值，稍微做个容错
            cellValue = {
                _display_: cellValue.display,
                ...cellValue,
            };
        }

        let extraProps = {};
        let fieldValue = {};
        switch (itemtype) {
            case 'input':
                if (autoRowHeight) {
                    extraProps.itemtype = 'textarea';
                    extraProps.rows = 1;
                    extraProps.autoHeight = true;
                }
                extraProps.isCheckChinese = true;
                extraProps.showClose = columnInfo.hasOwnProperty('showClose') ? columnInfo.showClose : true;
                extraProps.trim = true;
                break;
            case 'textarea':
                extraProps.isCheckChinese = true;
                extraProps.rows = 1;
                extraProps.trim = true;
                if (autoRowHeight) {
                    extraProps.autoHeight = true;
                }
                break;
            case 'number':
                // 先取数据精度，没有再取模板精度，默认是0
                extraProps.scale = Number(ERROR_SCALE.has(cellValue?.scale) ? ERROR_SCALE.has(columnInfo?.scale) ? 0 : columnInfo?.scale : cellValue?.scale) ?? 0;
                cellValue = {
                    ...cellValue,
                    title: cellValue?._display_ || cellValue?.display || cellValue?.value,
                    _display_: formatNumber(formatAcuracyRound(cellValue?.value, extraProps.scale)), // 数据格式里有颜色
                };
                break;
            case 'refer':
                let { refcondition: refCondition } = columnInfo;
                refCondition && (refCondition = JSON.parse(refCondition));
                if (Array.isArray(refCondition) && row.values) {
                    let meta = pageScope.state.meta;
                    extraProps.refRelyCondition = () => refCondition.filter(condition => typeof condition === 'object' && condition.key && condition.value).map(condition => {
                        if (condition.valueType !== 'const') {
                            let __cellValue = row.values[condition.value];
                            if (condition.areacode && condition.areacode !== id) {
                                let formMainId = condition.areacode;
                                meta?.formrelation && Object.keys(meta.formrelation).some(key => {
                                    if (meta.formrelation[key]?.includes(condition.areacode) && meta[key].moduletype === 'form') {
                                        formMainId = key;
                                        return true;
                                    }
                                });
                                meta?.formassociatedrelation && Object.keys(meta.formassociatedrelation).some(key => {
                                    if (meta.formassociatedrelation[key]?.['formtabs']?.includes(formMainId) && meta[key].moduletype === 'form') {
                                        formMainId = key;
                                        return true;
                                    }
                                });
                                __cellValue = pageScope.form.getFormItemsValue(formMainId, condition.value);
                            }
                            condition = {
                                ...condition,
                                value: __cellValue?.value,
                            };
                        }

                        return condition;
                    });
                }
                if (autoRowHeight) {
                    extraProps.inputType = 'textarea';
                    extraProps.autoHeight = true;
                }
                // 表格里不阻止冒泡，因为enter要跳到下一个单元格
                extraProps.stopPropagationWhenDropdownPressEnter = false;
                break;
            case 'switch_browse':
                extraProps.disabled = status === 'edit' || cellProps?.disabled;
                this.isEditable = this.isEditable && !extraProps.disabled;
            // eslint-disable-next-line no-fallthrough
            case 'switch':
            case 'checkbox_switch':
                editType = 'normal';
                isEditStatus && (isActive = true);
                autoFocus = false;
                break;
            case 'attachment':
                status === 'edit' && (extraProps.disableModify = true);
                editType = 'normal';
                isActive = true;
                autoFocus = false;
                extraProps.useTitle = false;
                extraProps.rowInfo = rowInfo; 
                extraProps.colInfo = columnInfo;
                extraProps.pkname = pkname;
                if (attachmentParams) {
                    let params = JSON.parse(attachmentParams) || [];
                    let meta = pageScope.state.meta;
                    params.forEach(item => {
                        let { areacode, parmasCode: paramsCode, parmasType: paramsType, value } = item;
                        {
                            if (paramsType === 'field') {// 如果是字段类型，取字段的值
                                if (meta.areacode?.moduletype === "form") {
                                    let mainId = getMainId(areacode, meta);
                                    let formValue = pageScope?.form?.getFormItemsValue(
                                        mainId,
                                        value,
                                    );
                                    fieldValue[paramsCode] = formValue?.value || '';
                                } else { //表格
                                    let cellValue = getCellValue(
                                        rowKey,
                                        value,
                                    );
                                    fieldValue[paramsCode] = cellValue?.value || '';
                                }
                            } else if (paramsType === 'const') {
                                // 如果是常量，直接赋值
                                fieldValue[paramsCode] = value;
                            }
                        }
                    });
                }
                extraProps.customize = { ...fieldValue, ...columnInfo.customize, [pkname]:row[pkname]?.value }; //行主键的优先级高于模板配置
                break;
            case 'residtxt':
                extraProps.trim = true;
                break;
            default:
                break;
        }

        if (hyperLinkFlag && hyperLinkType === '2' && hyperLinkUrl && itemtype !== 'refer') {
            isEditStatus = false;
        }

        if (isEditStatus) {
            // 单元格编辑态
            if (isActive) {
                // 单元格激活态
                return <Item
                    placeholder={hintmessage}
                    {...columnInfo}
                    {...cellProps}
                    {...extraProps}
                    onBlur={() => this.pasting = false}
                    title={cellValue?.title || cellValue?._display_}
                    path={[this.itemID]}
                    browse={false}
                    editType={editType}
                    autoFocus={autoFocus}
                    onStatusChange={({ isEdit }) => {
                        this.isEdit = isEdit;
                        // 只有当前单元格激活，才能取消激活，防止误伤
                        if (getActiveCell().rowKey === rowKey && getActiveCell().colKey === colKey && !isEdit) {
                            setActiveCell({ colKey: '', rowKey: '' });
                        }
                    }}
                    getFieldValue={({ attrcode }) => {
                        return store.getCellValue(rowKey, attrcode);
                    }}
                    setFieldValue={({ attrcode, value, componentValue }) => {
                        if (this.pasting) {
                            return;
                        }

                        this.dirty = true;
                        this.oldComponentValue = componentValue;

                        //胡杰李忠博加
                        if (typeof inputChange === 'function' && !inputChange({ index: row.dataIndex, item: columnInfo, valueChange: value.value })) {
                            // 转换一下index
                            return;
                        }
                        store.setCellValue(rowKey, attrcode, { value });
                        onValueChange?.(rowKey, { attrcode, value });
                    }}
                    onBeforeEvent={({ value, event }) => {
                        this.oldValue = value;
                        return onBeforeEvent?.({ value, event, colKey, rowKey });
                    }}
                    onAfterEvent={({ value, oldValue, componentValue, event }) => {
                        if (this.pasting) {
                            this.pasting = false;
                        } else {
                            this.dirty = false;
                            onAfterEvent?.({ value, oldValue, componentValue, event, colKey, rowKey });
                        }
                    }}
                    renderItem={({ isEdit }) => {
                        if (isEdit) {
                            // 编辑态时的编辑态
                            if (renderStatus === 'customer') {
                                return render(cellValue, row, getRowData(rowKey).dataIndex, store, 'edit');
                            } else if (renderItem) {
                                return renderItem(cellValue, row, getRowData(rowKey).dataIndex);
                            } else if ((renderStatus === 'edit' || !renderStatus) && render) {
                                return render(cellValue, row, getRowData(rowKey).dataIndex);
                            } else {
                                // renderItem是null，但Item要undefined才走默认渲染
                                return renderItems?.[colKey] ?? undefined;
                            }
                        }
                    }}
                    renderInTable
                />;
            } else {
                // 单元格非激活态
                if (renderStatus === 'customer' && render) {
                    let content = render(cellValue, row, getRowData(rowKey).dataIndex, store, 'editBrowse');

                    if (content === undefined) {
                        return this.renderStandardBrowse(cellValue, isEditStatus);
                    } else {
                        return this.renderTooltip(cellValue?.title || cellValue?._display_, <div
                            className="table-cell-browse"
                        >
                            {content}
                        </div>);
                    }
                } else if (renderStatus === 'editBrowse' && render) {
                    return this.renderTooltip(cellValue?.title || cellValue?._display_, <div
                        className="table-cell-browse"
                    >
                        {render(cellValue, row, getRowData(rowKey).dataIndex)}
                    </div>);
                } else {
                    return this.renderStandardBrowse(cellValue, isEditStatus);
                }
            }
        } else {
            // 单元格浏览态
            if (renderStatus === 'customer' && render) {
                let content = render(cellValue, row, getRowData(rowKey).dataIndex, store, 'browse');

                if (content === undefined) {
                    return this.renderStandardBrowse(cellValue);
                } else {
                    return this.renderTooltip(cellValue?.title || cellValue?._display_, <div
                        className="table-cell-browse"
                    >
                        {content}
                    </div>);
                }
            } else if (renderStatus === 'browse' && render) {
                return this.renderTooltip(cellValue?.title || cellValue?._display_, <div
                    className="table-cell-browse"
                >
                    {render(cellValue, row, getRowData(rowKey).dataIndex)}
                </div>);
            } else if (hyperLinkFlag) {
                let { colKey, store } = this.props,
                    columnInfo = store.getColumnProps(colKey),
                    cellProps = store.getCellProps(rowKey, colKey),
                    { contentcolor: columnColor } = columnInfo,
                    { color: cellColor } = cellProps.style || {},
                    contentcolor = cellColor || columnColor;
                return this.renderTooltip(
                    hyperLinkName ?? hyperLinkUrl ?? (cellValue?.title || cellValue?._display_),
                    <Hyperlink
                        name={hyperLinkName}
                        url={hyperLinkUrl}
                        type={hyperLinkType}
                        cellValue={cellValue}
                        itemType={itemtype}
                        meta={pageScope.state.meta}
                        tableId={id}
                        currentId={currentId}
                        colKey={colKey}
                        locale={locale}
                        datatype={datatype}
                        style={{ color: contentcolor }}
                        className={classNames(
                            'cell-hyper',
                            'code-detail-link',
                            { 'hyper-link-out': hyperLinkType === '2' && hyperLinkUrl && itemtype !== 'refer' },
                        )}
                    >
                        {/* {hyperLinkName ?? hyperLinkUrl ?? cellValue?._display_} */}
                    </Hyperlink>);
            } else {
                return this.renderStandardBrowse(cellValue);
            }
        }
    }

    renderTooltip = (overlay = '', content) => {
        let { showTip } = this.state,
            { colKey, store } = this.props,
            { itemtype } = store.getColumnProps(colKey);

        if (showTip && itemtype !== 'attachment') {
            return <Tooltip
                placement="rightBottom"
                overlay={overlay}
                delay={1}
                inverse
                className="table-cell-tooltip"
            >
                {content}
            </Tooltip>;
        }

        return content;
    }

    renderStandardBrowse = (cellValue, isEditStatus) => {
        let { colKey, rowKey, store, fontClass, autoRowHeight } = this.props,
            columnInfo = store.getColumnProps(colKey),
            cellProps = store.getCellProps(rowKey, colKey),
            {
                ishighlight,
                contentcolor,
                isbold,
                designlabelcontent,
            } = columnInfo;
        let standardCell = this.renderTooltip(cellValue?.title || cellValue?._display_, <div
            className={classNames("table-cell-browse", { fontClass: `font-class-${fontClass}` }, { 'high-light': ishighlight }, { 'font-bold': isbold })}
            style={{ color: contentcolor, ...cellProps.style }}
        >
            {cellValue?._display_}
        </div>);

        if (designlabelcontent && !isEditStatus) { //非编辑态才显示
            let colStyleInfo; 
            try {
                colStyleInfo = JSON.parse(designlabelcontent)?.find(colStyle => colStyle.key === cellValue?.value);
            } catch (e) {
                console.log(e);
            }
            let { borderRadius, color, icon } = colStyleInfo || {};

            if (colStyleInfo && cellValue?._display_) {
                return this.renderTooltip(cellValue?._display_, <div className='table-cell-browse' style={{ position: 'relative', right: '6px', width: '100%' }}>
                    <Hexagon
                        text={cellValue?._display_}
                        backgroundColor={color}
                        borderRadius={borderRadius}
                        icon={icon}
                        height={''}
                        maxWidth={'100%'}
                        isEllipsisRender={!autoRowHeight}
                    />
                </div>);
            } else {
                return standardCell;
            }
        }
        return standardCell;
    }

    // switch类型，浏览态前面需要加图标
    renderPrefixIcon = (itemtype, { isEditStatus }, { renderStatus, render }) => {
        if (isEditStatus) {
            return null;
        }
        let { colKey, rowKey, store } = this.props,
            cellValue = store.getCellValue(rowKey, colKey);

        if (new Set(['checkbox_switch', 'switch', 'switch_browse']).has(itemtype) && !renderStatus && !render) {
            let { colKey, rowKey, store } = this.props,
                { value } = store.getCellValue(rowKey, colKey) || {};

            if (value === 'Y') {
                value = true;
            } else if (value === 'N') {
                value = false;
            }

            // return <i
            //     style={{
            //         width: '8px',
            //         height: '8px',
            //         display: 'inline-block',
            //         borderRadius: '4px',
            //         marginRight: '6px',
            //         backgroundColor: value ? 'rgba(40,202,66,1)' : 'rgba(255,95,87,1)',
            //         flex: 'none',
            //     }}
            // ></i>;
            return <span className='icon-switch'>
                <i style={{ backgroundColor: value ? 'rgba(39,196,76,1)' : 'rgba(240,77,88,1)' }}
                    className={`iconfont icon-item-switch ${value ? 'icon-queding' : 'icon-quxiao'}`} />
                {cellValue._display_}
            </span>;
        }
    }

    // 参照和日期类型，后面要加图标
    renderSuffixIcon = (itemtype, { isEditStatus, isActive, disabled }) => {
        let { colKey, rowKey, store } = this.props;

        if (!isEditStatus || isActive || disabled) {
            return null;
        }

        // 点图标时要自动打开
        if (itemtype === 'refer') {
            return <i
                className='iconfont icon-canzhaozuixin hover-icon'
                onClick={() => {
                    store.setCellProps(rowKey, colKey, { autoShow: true });
                    // 延迟1500ms极大部分场景都没问题，暂无更好办法
                    setTimeout(() => {
                        store.setCellProps(rowKey, colKey, { autoShow: false });
                    }, 1500);
                }}
            ></i>;
        } else if (dateTypes.has(itemtype)) {
            return <i
                className='iconfont icon-rilizuixin hover-icon'
                onClick={() => {
                    store.setCellProps(rowKey, colKey, { autoOpenWhenFocus: true });
                    // 延迟1500ms极大部分场景都没问题，暂无更好办法
                    setTimeout(() => {
                        store.setCellProps(rowKey, colKey, { autoOpenWhenFocus: false });
                    }, 1500);
                }}
            ></i>;
        } else if (timeTypes.has(itemtype)) {
            return <i
                className='iconfont icon-shijian hover-icon'
                onClick={() => {
                    store.setCellProps(rowKey, colKey, { autoOpenWhenFocus: true });
                    // 延迟1500ms极大部分场景都没问题，暂无更好办法
                    setTimeout(() => {
                        store.setCellProps(rowKey, colKey, { autoOpenWhenFocus: false });
                    }, 1500);
                }}
            ></i>;
        } else if (selectTypes.has(itemtype)) {
            return <i
                className='wui-icon uf uf-arrow-down hover-icon'
                onClick={() => {
                    store.setCellProps(rowKey, colKey, { defaultOpen: true, autoFocus: true });
                    // 延迟1500ms极大部分场景都没问题，暂无更好办法
                    setTimeout(() => {
                        store.setCellProps(rowKey, colKey, { defaultOpen: false, autoFocus: false });
                    }, 1500);
                }}
            ></i>;
        }
    }

    handlePaste = event => {
        let { colKey, rowKey, store } = this.props,
            { getColumnProps, getCellValue } = store,
            locale = store.getLocale(),
            columnInfo = getColumnProps(colKey),
            visibleRows = store.getVisibleRows(),
            currentRow = store.getRowData(rowKey),
            { disabled } = store.getCellProps(rowKey, colKey),
            { isCustomerPaste, onBatchChange } = store.getConfig(),
            { itemtype, isconverttimezones: isConvertTimeZones, options, maxlength: maxLength, scale, min, max, disabledBatchChange } = columnInfo;

        let forbidPasteState = disabledBatchChange || !onBatchChange || colKey !== store.getFocusedCell()?.colKey || !(store.getStatus() !== 'browse' && itemtype !== 'label' && itemtype !== 'customer' && !disabled);
        if (forbidPasteState) { return; }

        let pasteText = (event.clipboardData || window.clipboardData)?.getData('text'),
            pasteTexts = [],
            dateFormat = [getDateTimeFormat('YYYY-MM-DD'), 'YYYY-MM-DD', 'YYYYMMDD', 'YYYY MM DD', 'YYYY.MM.DD', 'YYYY/MM/DD', 'YYYY-M-D', 'YYYYMD', 'YYYY M D', 'YYYY.M.D', 'YYYY/M/D'],
            dateTimeFormat = [getDateTimeFormat('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'YYYYMMDD HH:mm:ss', 'YYYY MM DD HH:mm:ss', 'YYYY.MM.DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss', 'YYYY-M-D HH:mm:ss', 'YYYYMD HH:mm:ss', 'YYYY M D HH:mm:ss', 'YYYY.M.D HH:mm:ss', 'YYYY/M/D HH:mm:ss'];

        let pasteFailToast = [];

        // 数字类型单元格可能会粘贴这种格式 "1.23 \r\n"
        while (pasteText.length && (pasteText[pasteText.length - 1] === '\n' || pasteText[pasteText.length - 1] === '\r')) {
            pasteText = pasteText.substr(0, pasteText.length - 1);
        }

        // 判断是否是单个单元格带换行（Excel会用双引号包裹）
        // Excel复制单个含\n的单元格格式为："内容行1\n内容行2"
        // 复制多个单元格格式为：行1\r\n行2\r\n行3（无引号包裹）
        const isSingleCellWithNewline = /^"[^"]*\n[^"]*"$/.test(pasteText);
        if (isSingleCellWithNewline) {
            // 单个单元格带换行，去掉引号后作为单行处理，不走批量粘贴逻辑
            return;
        }

        if (!/\n|\r/.test(pasteText) || !findDOMNode(this)?.contains(document.activeElement)) {
            // 单行时不走粘贴逻辑
            return;
        }

        if (/\t/.test(pasteText)) {
            // 多列时不走粘贴逻辑
            // console.warn('只能粘贴一列数据'); 产成品入库节点支持多列复制，不要这个提示
            !isCustomerPaste && toast({ color: 'danger', title: locale['table_tips'], content: locale['paste_multiple_col_error'], mark: 'paste_multiple_col_error', usePunctuation: false });
            pasteTexts = pasteText.split('\n').map(text => text.split('\t')[0]);
        } else if (/\r/.test(pasteText)) {
            pasteTexts = pasteText.split('\r').map(e => {
                if (typeof e === 'string') {
                    e = e.trim();
                    // excel单元格内容带\n时，粘贴时前后带"；单元格内容带"时，转为两个"
                    if (/^"[^"]*\n[^"]*"$/m.test(e)) {
                        e = e.slice(1, e.length - 1);
                    }
                    e = e.replaceAll('""', '"');
                }
                return e;
            });
        } else {
            pasteTexts = pasteText.split('\n').map(text => typeof text === 'string' ? text.trim() : text);
        }

        if (pasteTexts.length > 1) {
            onBatchChange && event.preventDefault();
            for (let i = 0; i < pasteTexts.length; i++) {
                let valLength = String(pasteTexts[i]).replace(/\·|[^\x00-\xff]/gi, "--").length;
                let text = pasteTexts[i];
                if (!text?.length) { //空白字符串均不处理
                    continue;
                }

                if (['input', 'textarea'].includes(itemtype) && maxLength && Number(maxLength) && valLength > maxLength) {
                    if (itemtype === 'input') {
                        if (valLength > text.length) { // 中文字符的问题
                            pasteTexts[i] = pasteTexts[i].slice(0, Math.floor(maxLength / 3));
                        } else {
                            pasteTexts[i] = pasteTexts[i].slice(0, maxLength);
                        }
                        pasteFailToast.push({
                            diff: i,
                            type: 'length',
                        });
                    } else {
                        pasteFailToast.push({
                            diff: i,
                            type: 'length',
                        });
                        pasteTexts[i] = undefined; //清空内容
                        continue;
                    }
                }

                if (itemtype === 'refer') {
                    // 避免触发参照编辑后
                    this.pasting = true;
                } else if (itemtype === 'number') {
                    //todo校验字符串
                    if (typeof text === 'string') {
                        text = text.replace(/,/g, '');
                    }
                    // 当数值类型只输入一个'-'的时候就将它赋值成0
                    if (text === '-') {
                        text = 0;
                    }
                    let reg = /^(-?\d+)(\.\d+)?$/; //数字，正数，负数，0，小数
                    if (text && typeof text === 'string' && text.length < 500 && !reg.test(text)) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                    } else if (typeof Number(min) !== 'undefined' && Number(text) < Number(min)) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'range',
                        });
                    } else if (typeof Number(max) !== 'undefined' && Number(text) > Number(max)) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'range',
                        });
                    } else {
                        let cellScale = getCellValue(visibleRows[currentRow.viewIndex + i]?.key, colKey)?.scale;
                        if (cellScale && Number(cellScale) >= 0) { // 数据有值，且大于等于0时，才按数据的精度，否则取模板
                            scale = String(cellScale);
                        }
                        if (Number(maxLength) > 0 && Number(scale) > 0 && text.split('.')[0]?.length + Number(scale) + 1 > Number(maxLength)) { // 小数点占位1
                            pasteTexts[i] = undefined; //清空内容
                            pasteFailToast.push({
                                diff: i,
                                type: 'length',
                            });
                        } else {
                            pasteTexts[i] = text && scale ? String(formatAcuracyRound(text, Number(scale), true)) : text;
                        }
                    }
                } else if (switchTypes.has(itemtype)) {
                    if(text === 'Y' || text === true) {
                        pasteTexts[i] = true;
                    } else if(text === "N" || text === false ) {
                        pasteTexts[i] = false;
                    } else { //不合法的值
                        pasteTexts[i] = false;
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                    }
                      
                } else if (itemtype === 'timepicker') {
                    let dateObj = dayjs('2022-12-01 '.concat(text), dateTimeFormat, true);
                    if (!dateObj.isValid() || text?.split(':').length !== 3) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                    } else {
                        pasteTexts[i] = dateObj.format('HH:mm:ss');
                    }
                } else if (itemtype === 'datetimepicker') {
                    let dateOnly = dayjs(text, dateFormat, true),
                        timeOnly = dayjs(text, dateTimeFormat, true);

                    if (!dateOnly.isValid() && !timeOnly.isValid()) { //小数复制到日期会被识别
                        text = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                        document.activeElement.blur();
                    } else if (timeOnly.isValid()) { // dateTimePicker 格式支持 YYYY-MM-DD HH:mm:ss
                        text = timeOnly.format('YYYY-MM-DD HH:mm:ss');
                    } else if (dateOnly.isValid()) {
                        text = dateOnly.format('YYYY-MM-DD') + ' ' + dayjs().format('HH:mm:ss');
                    }

                    if (text && !localIsEqualServerZone()) {
                        text = localTimeToServer(dayjs(text), isConvertTimeZones).format('YYYY-MM-DD HH:mm:ss');
                    }
                    pasteTexts[i] = text;
                } else if (pasteDateTypes.has(itemtype)/* && itemtype !== 'datetimepicker' */) {
                    let format = [...dateFormat, ...dateTimeFormat],
                        timeString = itemtype === 'NCTZDatePickerStart' ? '00:00:00'
                            : itemtype === 'NCTZDatePickerEnd' ? '23:59:59' : dayjs().format('HH:mm:ss');

                    let text = pasteTexts[i],
                        date = dayjs(text, format, true);
                    //判断合法性
                    if (!date.isValid()) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                        document.activeElement.blur();
                    } else {
                        text = `${date.format('YYYY-MM-DD')} ${timeString}`;

                        if (!localIsEqualServerZone() && itemtype !== 'datePickerNoTimeZone') {
                            text = localTimeToServer(dayjs(text), isConvertTimeZones).format('YYYY-MM-DD HH:mm:ss');
                        }
                        pasteTexts[i] = text;
                    }
                } else if (itemtype === 'select') {
                    text = options.find(option => option.display == text)?.value;
                    if (typeof text !== 'undefined') {
                        pasteTexts[i] = text;
                    } else {
                        pasteTexts[i] = undefined;
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                    }
                } else if (itemtype === 'input' && ['vchangerate', 'vqtunitrate'].includes(colKey)) {
                    let reg = /^([1-9][0-9]*|0)(\.\d{1,})?(\/)(([1-9][0-9]*)(\.\d{1,})?|(\d\.\d{1,}))$/;
                    if (text && text.length < 1000 && !reg.test(text)) {
                        pasteTexts[i] = undefined; //清空内容
                        pasteFailToast.push({
                            diff: i,
                            type: 'format',
                        });
                    } else {
                        pasteTexts[i] = text;
                    }
                }
            }
        }
        if (pasteFailToast.length) {
            store.pasteInfo = {
                success: false,
                pasteFailToast,
                rowKey,
                columnInfo,
                maxLength,
                min,
                max,
            };
        } else {
            store.pasteInfo = { success: true, rowKey };
        }
        if (pasteTexts.some(text => typeof text !== 'undefined')) {
            this.handleBatchChange(
                pasteTexts.map(text => ({
                    display: text,
                    value: text,
                })),
                pasteTexts,
            );
        } else if (pasteFailToast.length) {
            store.pasteInfo = undefined; //清空pastInfo，否则下拉批选会用到旧的信息 YBP-SCM-BUG-5956
            toast({
                color: 'danger',
                mark: 'paste-fail-toast',
                usePunctuation: false,
                // 共粘贴${1}条。成功${2}条，失败${3}条：
                title: (locale['table0045'] || '')
                    .replace('${1}', pasteTexts.length)
                    .replace('${2}', pasteTexts.length - pasteFailToast.length)
                    .replace('${3}', pasteFailToast.length)
                    .concat('\n'),
                content: pasteFailToast.map(({ diff, type }, index) => {
                    if (type === 'length') {
                        // 第${1}条：${2}，最大录入长度为${3}；
                        return (locale[index === pasteFailToast.length - 1 ? 'table0047' : 'table0046'] || '')
                            .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                            .replace('${2}', columnInfo.label)
                            .replace('${3}', maxLength)
                            .concat('\n');
                    } else if (type === 'range') {
                        if (typeof min === 'undefined') { min = Number.MIN_VALUE; }
                        if (typeof max === 'undefined') { max = Number.MAX_VALUE; }
                        // 第${1}条：${2}，输入值必须介于[${3},${4}]；
                        return (locale[index === pasteFailToast.length - 1 ? 'table0052' : 'table0051'] || '')
                            .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                            .replace('${2}', columnInfo.label)
                            .replace('${3}', min)
                            .replace('${4}', max)
                            .concat('\n');
                    } else {
                        // 第${1}条：${2}，格式错误；
                        return (locale[index === pasteFailToast.length - 1 ? 'table0049' : 'table0048'] || '')
                            .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                            .replace('${2}', columnInfo.label)
                            .concat('\n');
                    }
                }),
            });
        }
    }

    handleBatchChange = (pasteValue, texts) => {
        let { store, rowKey, colKey } = this.props,
            { cellSelectConfig } = store.getInstance().getComponent('Table').current.props,
            rows = store.getVisibleRows(),
            row = store.getRowData(rowKey),
            column = store.getColumnProps(colKey),
            oldValues = [],
            selectedRows = pasteValue.map((value, index) => {
                let currentRow = rows[row.viewIndex + index];
                if (currentRow) {
                    oldValues.push(currentRow.values[colKey]);
                    return {
                        ...currentRow,
                        values: {
                            ...currentRow.values,
                            [colKey]: value,
                        },
                    };
                } else {
                    oldValues.push({});
                    let rowKey = String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);
                    return {
                        key: rowKey,
                        rowid: rowKey,
                        rowId: rowKey,
                        status: ROW_STATUS.ADD,
                        values: { [colKey]: value },
                    };
                }
            });

        cellSelectConfig?.onChange(selectedRows, { column, row, oldValues, texts });
    }

    focus = () => {
        let cell = findDOMNode(this),
            item = cell?.querySelector('.template-item-wrapper');
        (item || cell).focus();
    }

    blur = () => {
        // 只有当前单元格激活，才能失焦，防止误伤
        if (findDOMNode(this)?.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    }
}